window.i18n = require('./vendor/i18n');
window.DirectorRouter = require('./vendor/director.min.js').Router;
window.ajax = require('reqwest');
window.classNames = require('classnames');
require('./vendor/array-includes-polyfill.js');
require('./vendor/remove-outline.js');
require('./vendor/dataset-shim.js');



/** WEBPACK FOOTER **
 ** ./src/js/vendor.jsx
 **/